<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="站点名称">
          <el-input
            v-model="queryParams.stationName"
            clearable
            placeholder="请输入站点名称"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item v-if="isAdminUser" label="所属运营商">
          <el-select v-model="queryParams.operatorId" clearable filterable placeholder="请选择运营商">
            <el-option
              v-for="item in operatorOptions"
              :key="item.id"
              :label="item.operatorName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button type="success" icon="el-icon-upload" @click="handleImport">导入</el-button>
      <el-button type="info" icon="el-icon-download" @click="handleDownloadTemplate">充电站导入模板</el-button>
      <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="stationList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="所属运营商" prop="operatorName" width="140" show-overflow-tooltip />
        <el-table-column label="站点名称" prop="stationName" min-width="180" show-overflow-tooltip />
        <el-table-column label="站点编码" prop="stationCode" min-width="160" show-overflow-tooltip />
        <el-table-column label="所在区" prop="district" width="100" />
        <el-table-column label="安装地址" prop="address" min-width="220" show-overflow-tooltip />
        <el-table-column label="安装类型" prop="type" width="100" />
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="getPushStatusType(scope.row.pushStatus)">
              {{ scope.row.pushStatusDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最后推送时间" prop="lastPushTime" width="180" />
        <el-table-column label="推送记录" align="center" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleViewPushLog(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <el-dialog title="推送记录" :visible.sync="pushLogOpen" width="1000px">
      <el-table :data="pushLogList" border>
        <el-table-column label="推送时间" prop="createdTime" width="180" />
        <el-table-column label="接口URL" prop="interfaceUrl" min-width="220" show-overflow-tooltip />
        <el-table-column label="响应体" prop="responseBody" min-width="240" show-overflow-tooltip />
        <el-table-column label="错误消息" prop="errorMessage" min-width="240" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleRetryPush(scope.row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pushLogTotal > 0"
        :current-page.sync="pushLogQuery.pageNum"
        :page-size.sync="pushLogQuery.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pushLogTotal"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="loadPushLog"
        @current-change="loadPushLog"
      />
    </el-dialog>

    <el-dialog :title="title" :visible.sync="open" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="站点名称" prop="stationName">
              <el-input v-model="form.stationName" placeholder="请输入站点名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点编码" prop="stationCode">
              <el-input v-model="form.stationCode" placeholder="请输入站点编码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="省市区" prop="district">
              <v-distpicker
                :province="form.province"
                :city="form.city"
                :area="form.district"
                @province="selectProvince"
                @city="selectCity"
                @area="selectDistrict"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="街道/镇" prop="street">
              <el-input v-model="form.street" placeholder="请输入街道/镇" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="居委会" prop="communityCommittee">
              <el-input v-model="form.communityCommittee" placeholder="请输入居委会" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" type="textarea" placeholder="请输入详细地址" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度" prop="lon">
              <el-input v-model="form.lon" placeholder="请输入经度" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="lat">
              <el-input v-model="form.lat" placeholder="请输入纬度" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="安装类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择安装类型">
                <el-option label="小区" value="小区" />
                <el-option label="园区" value="园区" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资源来源" prop="source">
              <el-select v-model="form.source" placeholder="请选择资源来源">
                <el-option label="公司" value="公司" />
                <el-option label="个人" value="个人" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物业公司名称" prop="wuyeCompany">
              <el-input v-model="form.wuyeCompany" placeholder="请输入物业公司名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物业联系人" prop="wuyeContacts">
              <el-input v-model="form.wuyeContacts" placeholder="请输入物业联系人" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物业电话" prop="wuyePhone">
              <el-input v-model="form.wuyePhone" placeholder="请输入物业电话" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入充电站" :visible.sync="importOpen" width="400px">
      <el-upload
        ref="upload"
        drag
        action="#"
        :auto-upload="false"
        :on-change="handleFileChange"
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div slot="footer">
        <el-button @click="importOpen = false">取消</el-button>
        <el-button type="primary" @click="submitImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listStation, getStation, addStation, updateStation, delStation, pushStation, batchPushStation, importStation, exportStation } from '@/api/coo/station'
import { listOperator } from '@/api/coo/operator'
import { listPushLog, retryPush } from '@/api/coo/push'
import VDistpicker from 'v-distpicker'

const DEFAULT_PROVINCE = '上海市'
const DEFAULT_PROVINCE_CODE = '310000'
const DEFAULT_CITY = '上海市'
const DEFAULT_CITY_CODE = '310100'

export default {
  name: 'StationList',
  components: {
    VDistpicker
  },
  data() {
    return {
      loading: true,
      open: false,
      importOpen: false,
      pushLogOpen: false,
      title: '',
      stationList: [],
      pushLogList: [],
      pushLogTotal: 0,
      pushLogQuery: {
        pageNum: 1,
        pageSize: 10
      },
      operatorOptions: [],
      currentStation: null,
      isAdminUser: false,
      total: 0,
      multiple: true,
      ids: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        stationName: undefined,
        operatorId: undefined
      },
      form: {},
      rules: {
        stationCode: [{ required: true, message: '站点编码不能为空', trigger: 'blur' }],
        province: [{ required: true, message: '省份不能为空', trigger: 'change' }],
        city: [{ required: true, message: '城市不能为空', trigger: 'change' }],
        district: [{ required: true, message: '区县不能为空', trigger: 'change' }],
        address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '安装类型不能为空', trigger: 'change' }]
      },
      importFile: null
    }
  },
  created() {
    this.reset()
    this.initCurrentUser()
    this.initOperatorOptions()
    this.getList()
    this.$guide.startGuideIfNeeded('station')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('station')
    },
    initCurrentUser() {
      const user = JSON.parse(window.sessionStorage.getItem('user') || '{}')
      const roleNames = (user.roles || []).map(item => item.name)
      this.isAdminUser = user.username === 'admin' || roleNames.includes('ROLE_admin')
    },
    initOperatorOptions() {
      if (!this.isAdminUser) {
        return
      }
      listOperator({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.operatorOptions = response.data || []
      })
    },
    getList() {
      this.loading = true
      listStation(this.queryParams).then(response => {
        this.stationList = response.data || []
        this.total = response.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        stationName: undefined,
        operatorId: undefined
      }
      this.handleQuery()
    },
    getPushStatusType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'info'
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.multiple = !selection.length
    },
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '新增充电站'
    },
    handleUpdate(row) {
      this.reset()
      getStation(row.id).then(response => {
        this.form = this.normalizeForm(response.data || {})
        this.open = true
        this.title = '编辑充电站'
      })
    },
    handleDelete(row) {
      const ids = row.id || this.ids.join(',')
      this.$confirm('确认删除选中的充电站吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => delStation(ids)).then(response => {
        if (response && response.code === 200) {
          this.getList()
          this.$message.success(response.message || '删除成功')
        } else if (response) {
          this.$message.error(response.message || '删除失败')
        }
      })
    },
    handlePush(row) {
      pushStation(row.id).then(response => {
        if (response.code === 200) {
          this.$message.success(response.message || '推送成功')
          this.getList()
        } else {
          this.$message.error(response.message || '推送失败')
        }
      })
    },
    handleViewPushLog(row) {
      this.currentStation = row
      this.pushLogOpen = true
      this.pushLogQuery.pageNum = 1
      this.loadPushLog(row.stationCode)
    },
    loadPushLog() {
      if (!this.currentStation) return
      const dataId = this.currentStation.stationCode
      listPushLog({ dataType: 'station', dataId, ...this.pushLogQuery }).then(response => {
        this.pushLogList = response.data || []
        this.pushLogTotal = response.total || 0
      })
    },
    handleRetryPush(log) {
      this.$confirm('确认重新推送这条记录吗？', '提示', {
        type: 'warning'
      }).then(() => retryPush(log.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '重试成功')
          if (this.currentStation) {
            this.loadPushLog()
          }
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '重试失败')
        }
      })
    },
    handleBatchPush() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要推送的充电站')
        return
      }
      this.$confirm('确认推送选中的充电站吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => batchPushStation({ ids: this.ids })).then(response => {
        if (response && response.code === 200) {
          this.$message.success(`批量推送完成，成功 ${response.successCount} 条，失败 ${response.failCount} 条`)
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '批量推送失败')
        }
      })
    },
    handleImport() {
      this.importOpen = true
    },
    handleFileChange(file) {
      this.importFile = file.raw
    },
    submitImport() {
      if (!this.importFile) {
        this.$message.warning('请选择要导入的文件')
        return
      }
      const formData = new FormData()
      formData.append('file', this.importFile)
      importStation(formData).then(response => {
        if (response.code === 200) {
          this.$message.success(`导入完成，成功 ${response.successCount} 条，失败 ${response.failCount} 条`)
          this.importOpen = false
          this.importFile = null
          this.getList()
        } else {
          this.$message.error(response.message || '导入失败')
        }
      })
    },
    handleDownloadTemplate() {
      const link = document.createElement('a')
      link.href = '/api/coo/template/station/template'
      link.download = '充电站导入模板.xlsx'
      link.click()
    },
    handleExport() {
      exportStation({}).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '充电站数据.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const payload = this.buildSubmitForm()
        const request = payload.id ? updateStation(payload) : addStation(payload)
        request.then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '保存成功')
            this.open = false
            this.getList()
          } else {
            this.$message.error(response.message || '保存失败')
          }
        })
      })
    },
    buildSubmitForm() {
      return {
        id: this.form.id,
        operatorId: this.form.operatorId,
        operatorName: this.form.operatorName,
        stationName: this.form.stationName,
        stationCode: this.form.stationCode,
        province: this.form.province,
        provinceCode: this.form.provinceCode,
        city: this.form.city,
        cityCode: this.form.cityCode,
        district: this.form.district,
        districtCode: this.form.districtCode,
        street: this.form.street,
        communityCommittee: this.form.communityCommittee,
        address: this.form.address,
        lon: this.form.lon,
        lat: this.form.lat,
        type: this.form.type,
        wuyeCompany: this.form.wuyeCompany,
        wuyeContacts: this.form.wuyeContacts,
        wuyePhone: this.form.wuyePhone,
        source: this.form.source
      }
    },
    cancel() {
      this.open = false
      this.reset()
    },
    selectProvince({ code, value }) {
      this.form.province = value || DEFAULT_PROVINCE
      this.form.provinceCode = code || DEFAULT_PROVINCE_CODE
    },
    selectCity({ code, value }) {
      this.form.city = value || DEFAULT_CITY
      this.form.cityCode = code || DEFAULT_CITY_CODE
    },
    selectDistrict({ code, value }) {
      this.form.district = value || undefined
      this.form.districtCode = code || undefined
    },
    normalizeForm(form = {}) {
      return {
        ...form,
        province: form.province || DEFAULT_PROVINCE,
        provinceCode: form.provinceCode || DEFAULT_PROVINCE_CODE,
        city: form.city || DEFAULT_CITY,
        cityCode: form.cityCode || DEFAULT_CITY_CODE,
        districtCode: form.districtCode || undefined,
        type: form.type || '小区',
        source: form.source || '公司'
      }
    },
    reset() {
      this.form = this.normalizeForm({
        province: DEFAULT_PROVINCE,
        provinceCode: DEFAULT_PROVINCE_CODE,
        city: DEFAULT_CITY,
        cityCode: DEFAULT_CITY_CODE,
        type: '小区',
        source: '公司'
      })
    }
  }
}
</script>

<style scoped>
.search-card,
.action-card {
  margin-bottom: 15px;
}
</style>
